import Apify from '@wetransfer/transfer/modules/apify';

export default Apify({
  getInvoices: {
    path: '/api/v4/nu_invoices',
    method: 'GET',
  },

  getInvoice: {
    path: '{downloadUrl}',
    method: 'GET',
    pathExt: true,
  },

  getHostedInvoice: {
    path: '/api/v4/nu_invoices/{invoiceId}',
    pathExt: true,
    method: 'GET',
  },

  getUnpaidInvoices: {
    path: '/api/v4/nu_invoices/unpaid',
    method: 'GET',
  },
});
